module.exports = __webpack_public_path__ + "components/media-kit/static/logo--Intersport-208ff4d895c4e61e1057f2c3a53458da.svg";